/* eslint-disable @typescript-eslint/no-shadow */
import IMapService from '../../types/IMapService';
import getStylesheetPath from './getStylesheetPath';

const loadStylesheet = (service: IMapService): void => {
  const { type, loadStylesheet } = service;
  const stylesheet: string | null = getStylesheetPath(type.value);

  if (!stylesheet) return;

  loadStylesheet(stylesheet);
};

export default loadStylesheet;
